import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { handleApi } from "../../utils/authentication";
import logo from "../../assests/logo.png";
import LoadingSpinner from "../../components/client/LoadingSpinner";

const ViewTermsAndConditions = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const getTermsAndConditions = async () => {
    try {
      setLoading(true); // Start loading
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" }); // Create a Blob from the content

      let method = "GET";
      let headers = {};

      let result = await handleApi("get_terms_and_conditions", method, headers);

      if (result?.success) {
        setContent(result?.data?.content);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Something went wrong! Please Try again later",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          },
        );
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };
  useEffect(() => {
    getTermsAndConditions();
  }, []);

  return (
    <div className="w-100 tc_main pb-5">
      <div className="tc_navbar d-flex align-items-center">
        <div className="container ">
          <div className="d-flex gap-2 align-items-center justify-content-center">
            <div className="tc_logo">
              <img src={logo} alt="" className="w-100 h-100" />
            </div>

            <div
              className={` tc_heading  d-flex justify-content-center gap-2 `}
            >
              <p className="mb-0">University </p>
              <p className="mb-0">Intelligence</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-4 tc_content position-relative">
        {loading && <LoadingSpinner />}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default ViewTermsAndConditions;
